"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categories = void 0;
// eslint-disable-next-line import/prefer-default-export
var categories = exports.categories = function categories(state, _ref) {
  var organizationId = _ref.organizationId;
  return state.categories.data[organizationId];
};
//# sourceMappingURL=selectors.js.map